import type { Editor } from "@tiptap/core";
import type { Range } from "@tiptap/core";

type OpenEmbedModalFn = (
  editor: Editor,
  range: Range,
  position?: { top: number; left: number },
  /** Connector id from lib/embed-connectors, for the per-app copy. */
  provider?: string | null
) => void;

let openEmbedModalFn: OpenEmbedModalFn | null = null;
let closeEmbedModalFn: (() => void) | null = null;
let isEmbedModalOpenFn: (() => boolean) | null = null;
let getEmbedModalRangeFn: (() => Range | null) | null = null;

export function setOpenEmbedModal(fn: OpenEmbedModalFn | null) {
  openEmbedModalFn = fn;
}

export function setCloseEmbedModal(fn: (() => void) | null) {
  closeEmbedModalFn = fn;
}

export function setIsEmbedModalOpen(fn: (() => boolean) | null) {
  isEmbedModalOpenFn = fn;
}

export function setGetEmbedModalRange(fn: (() => Range | null) | null) {
  getEmbedModalRangeFn = fn;
}

export function openEmbedModal(
  editor: Editor,
  range: Range,
  position?: { top: number; left: number },
  provider?: string | null
) {
  if (openEmbedModalFn) {
    openEmbedModalFn(editor, range, position, provider);
  } else {
    console.warn("EmbedModal not initialized. Falling back to prompt.");
    const rawInput = prompt("Please enter a link to embed");
    if (rawInput === null) {
      return;
    }
  }
}

export function closeEmbedModal() {
  closeEmbedModalFn?.();
}

export function isEmbedModalOpen(): boolean {
  return isEmbedModalOpenFn?.() ?? false;
}

export function getEmbedModalRange(): Range | null {
  return getEmbedModalRangeFn?.() ?? null;
}
